import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-id-card-02',
	templateUrl: './icon-id-card-02.component.svg',
})
export class IconIdCard02Component {}
